export default __webpack_public_path__ + "b4f842c4115d595f5287ccf95a7bcabc.jpeg";